(function (mod) {
	if (typeof exports === "object") {
		module.exports = mod();
	}else{
		window.Mo = mod();
	}
})(function (){
var Mo = (function (){

/////////////////////////////////////////////////////////////////////////
// ↓ CreateJS Canvas Setting ↓
/////////////////////////////////////////////////////////////////////////

/** プロパティ */
	
var C = {
	id : "",
	canvas : {},
	canvases : {},
	ctx : {},
	stage : {},
	stages : [],
	space : {},
	size : {},
	resizeTimer : false,
	step: {},
	tick: {},
	rx: {},
	ry: {},
	set : setCanvas,
	fps :20
};
var B={},S={},W={};
/** IdからCanvasを取得、設定します
	stagesにstageオブジェクトをいれること。
*/
function setCanvas(){
	C.stages=[];
	C.canvases=[];
	
	
	//topcanvas
	S.id="D";
	S.canvas =document.getElementById(S.id);
	S.ctx = S.canvas.getContext("2d");
	var size=S.size=setSize(S.canvas,2,false,false,1557,1557);
	C.size = size;
    
	S.stage = new createjs.Stage(S.canvas);
	//S.stage.enableDOMEvents(true);
	S.stage.autoClear = false;
	
	S.space = new createjs.Container();
	S.space.set({x:S.size.margin.x,y:S.size.margin.y});
	S.stage.addChild(S.space);

	S.stage.alpha=0.0;
	//fadeIn(S.stage);
	C.stages.push(S.stage);
    
    
    
	//backcanvas
	B.id="I";
	B.canvas =document.getElementById(B.id);
	B.ctx = B.canvas.getContext("2d");
	B.size = setSize2(B.canvas,1,false,false,1557,1557);
	
	B.stage = new createjs.Stage(B.canvas);
	//S.stage.enableDOMEvents(true);
	S.stage.autoClear = true;
	
	B.space = new createjs.Container();
	B.space.set({x:B.size.margin.x,y:B.size.margin.y});
	B.stage.addChild(B.space);

	B.stage.alpha=0.0;
	//fadeIn(S.stage);
	C.stages.push(B.stage);


    
	//canvas
    
	W.id="J";
	W.canvas =document.getElementById(W.id);
	W.ctx = W.canvas.getContext("2d");
	W.size = setSize3(W.canvas,2,false,false,557,557);
	
	W.stage = new createjs.Stage(W.canvas);
	//S.stage.enableDOMEvents(true);
	W.stage.autoClear = true;
	
	W.space = new createjs.Container();
	W.space.set({x:W.size.margin.x,y:W.size.margin.y});
	W.stage.addChild(W.space);

	W.stage.alpha=0.0;
	//fadeIn(S.stage);
	C.stages.push(W.stage);
    
	
	//O.put("WebGL",(GL.stage.isWebGL)?"on":"off");

	C.canvases.push(B.canvas);
	C.canvases.push(S.canvas);
	C.canvases.push(W.canvas);
	//C.canvases.push(GL.canvas);
	//set CreateJS stage object
	
	FOC();
	setCreateJS();
}

	
/** CreateJSの設定 */
function setCreateJS(){
	/** フレームの更新にあわせるカウンター */
	C.step = (function() {
		var s=0;
		var m=0;
		return {
			count : function(p){s+=p;return s;},
			get : function(){return s;},
			set : function(p){s=p;return s;},
			reset : function(){s=0;return s;},
			max : m
		};
	})();
	C.step.max=60;

	/** ティッカー */
	C.tick=function(e){
		//FPS
		O.put("FPS",createjs.Ticker.getMeasuredFPS());

		if (!e.paused) {
			var step=C.step.count(1);
			/* update function - - - - - */
				//for(var i=0;i<10;i++){
					updateCanvas(step,C.step.max);
				//}
			/* - - - - - - - - - - - - - */
			if(step===C.step.max){C.step.reset()}
		}else{
			/*
			console.log(e.paused,
				 createjs.Ticker.getTime(false),
				 createjs.Ticker.getTime(true));
			*/
			//stageClear("rgba(255, 255, 255, 1.0)");
		}
        /*
        if(C.size.isSP){
            if(step%2===0){
                M.stage.update();
                S.stage.update();
                GL.stage.update();   
            }
        }else{
        */
            S.stage.update();
            B.stage.update();
            W.stage.update();
            //GL.stage.update();
        //}
        /*
		for(var i=0;i<C.stages.length;i++){
			C.stages[i].update();
		}
        */
	}

	//event
	createjs.Ticker.addEventListener("tick", C.tick);
	createjs.Ticker.setFPS(C.fps);
	createjs.Ticker.timingMode ="synched";
    
    window.addEventListener('resize', resizeCanvas);
 	createjs.Ticker.paused = false;
	
	//contents
	onYourMark();
}
	
/** ウィンドウサイズからCanvasのサイズを設定します */
function setSize(canvas,s,w,h,mw,mh){
	//ブラウザウィンドウサイズを取得し、キャンバスサイズを変更
    var ho=0.865;
	var winW = $("#starCanvas>img.imgfix").height();
	var winH = winW;

	
	var _maxCanW=mw||winW;
	var _maxCanH=mh||winH;
	var scale=s||1;
	var isAddMargin=false;
	
	//canvasサイズ
	var spcW,spcH;
		spcW = winW*ho;
		spcH = winH*ho;
	
	//マージンを付加
	var marLR,marTB;
		marLR = 0;
		marTB = 0;
	
	//キャンバスの位置とサイズを設定
	canvas.width = (spcW+marLR*2)*scale;
	canvas.height = (spcH+marTB*2)*scale;
	
	canvas.style.right = spcW*0.0248 + 'px';
	canvas.style.top = spcH*0.0527 + 'px';
    
	canvas.style.width = (spcW+marLR*2) + 'px';
	canvas.style.height = (spcH+marTB*2) + 'px';
	

	
	//
	O.put("windowW",winW+"px");
	O.put("windowH",winH+"px");
	O.put("canvasW",canvas.width+" ("+canvas.style.width+")");
	O.put("canvasH",canvas.height+" ("+canvas.style.height+")");
	O.put("spaceW",spcW*scale+" ("+spcW+"x"+scale+")");
	O.put("spaceH",spcH*scale+" ("+spcH+"x"+scale+")");
	O.put("margin",marLR*scale+" & "+marTB*scale);
    O.put("center",spcW*scale / 2+" & "+spcH*scale / 2);
	//
	
	var isSP=false;
    var isTB=false;
    var spread=0;
    var rate=winW/winH;
    /*
	if(winW<600){//スマホ
		isSP=true;
	}else{
        if(rate<1.1){//縦ながめデバイス
		  isTB=true;
	   }
        if(winW<1028){//補正
		  spread=(1028-winW)/(1028-599)*20;
	   }
    }
    */
    O.put("spread",spread);
	//オブジェクトのベーススケール
	var scaleW=winW/_maxCanW/2*scale;
	var scaleH=winH/_maxCanH/2*scale;
	var baseScale;
    baseScale=spcH/300;
	
	//サイズを返す
	return {
		stageW: canvas.width,
		stageH: canvas.height,
		W: spcW*scale,
		H: spcH*scale,
		spaceW: spcW*scale,
		spaceH: spcH*scale,
		centerX: spcW*scale / 2,
		centerY: spcH*scale / 2,
		isSP:isSP,
		isTB:isTB,
        spread:spread,
		scaleW:scaleW,
		scaleH:scaleH,
		baseScale: baseScale,
		scale: scaleH,
		margin: {x:marLR*scale,y:marTB*scale}
	};
}
function setSize2(canvas,s,w,h,mw,mh){
	//ブラウザウィンドウサイズを取得し、キャンバスサイズを変更
    //var ho=0.857;
	var winW = $(window).width();
	var winH = $(window).height();

	
	var _maxCanW=mw||winW;
	var _maxCanH=mh||winH;
	var scale=s||1;
	var isAddMargin=false;
	
	//canvasサイズ
	var spcW,spcH;
		spcW = winW;
		spcH = winH;
	
	//マージンを付加
	var marLR,marTB;
		marLR = 0;
		marTB = 0;
	
	//キャンバスの位置とサイズを設定
	canvas.width = (spcW+marLR*2)*scale;
	canvas.height = (spcH+marTB*2)*scale;
	
	canvas.style.right = (winW - (spcW+marLR*2)) / 2 + 'px';
	canvas.style.top = (winH - (spcH+marTB*2)) / 2 + 'px';
	canvas.style.width = (spcW+marLR*2) + 'px';
	canvas.style.height = (spcH+marTB*2) + 'px';
	

	
	//
	O.put("windowW",winW+"px");
	O.put("windowH",winH+"px");
	O.put("canvasW",canvas.width+" ("+canvas.style.width+")");
	O.put("canvasH",canvas.height+" ("+canvas.style.height+")");
	O.put("spaceW",spcW*scale+" ("+spcW+"x"+scale+")");
	O.put("spaceH",spcH*scale+" ("+spcH+"x"+scale+")");
	O.put("margin",marLR*scale+" & "+marTB*scale);
    O.put("center",spcW*scale / 2+" & "+spcH*scale / 2);
	//
	
	var isSP=false;
    var isTB=false;
    var spread=0;
    var rate=winW/winH;
    /*
	if(winW<600){//スマホ
		isSP=true;
	}else{
        if(rate<1.1){//縦ながめデバイス
		  isTB=true;
	   }
        if(winW<1028){//補正
		  spread=(1028-winW)/(1028-599)*20;
	   }
    }
    */
    O.put("spread",spread);
	//オブジェクトのベーススケール
	var scaleW=winW/_maxCanW/2*scale;
	var scaleH=winH/_maxCanH/2*scale;
	var baseScale;
    baseScale=spcH/300;
	
	//サイズを返す
	return {
		stageW: canvas.width,
		stageH: canvas.height,
		W: spcW*scale,
		H: spcH*scale,
		spaceW: spcW*scale,
		spaceH: spcH*scale,
		centerX: spcW*scale / 2,
		centerY: spcH*scale / 2,
		isSP:isSP,
		isTB:isTB,
        spread:spread,
		scaleW:scaleW,
		scaleH:scaleH,
		baseScale: baseScale,
		scale: scaleH,
		margin: {x:marLR*scale,y:marTB*scale}
	};
}
function setSize3(canvas,s,w,h,mw,mh){
	//ブラウザウィンドウサイズを取得し、キャンバスサイズを変更
    var ho=0.865;
	var winW = $("#starCanvas>img.imgfix").height();
	var winH = winW;

	
	var _maxCanW=mw||winW;
	var _maxCanH=mh||winH;
	var scale=s||1;
	var isAddMargin=false;
	
	//canvasサイズ
	var spcW,spcH;
		spcW = winW*ho;
		spcH = winH*ho;
	
	//マージンを付加
	var marLR,marTB;
		marLR = 0;
		marTB = 0;
	
	//キャンバスの位置とサイズを設定
	canvas.width = (spcW+marLR*2)*scale;
	canvas.height = (spcH+marTB*2)*scale;
	//setTimeout(function(){
	canvas.style.right = 0+ 'px';
	canvas.style.top = 0+ 'px';
    //},2000);
	canvas.style.width = (spcW+marLR*2) + 'px';
	canvas.style.height = (spcH+marTB*2) + 'px';
	

	
	//
	O.put("windowW",winW+"px");
	O.put("windowH",winH+"px");
	O.put("canvasW",canvas.width+" ("+canvas.style.width+")");
	O.put("canvasH",canvas.height+" ("+canvas.style.height+")");
	O.put("spaceW",spcW*scale+" ("+spcW+"x"+scale+")");
	O.put("spaceH",spcH*scale+" ("+spcH+"x"+scale+")");
	O.put("margin",marLR*scale+" & "+marTB*scale);
    O.put("center",spcW*scale / 2+" & "+spcH*scale / 2);
	//
	
	var isSP=false;
    var isTB=false;
    var spread=0;
    var rate=winW/winH;
    /*
	if(winW<600){//スマホ
		isSP=true;
	}else{
        if(rate<1.1){//縦ながめデバイス
		  isTB=true;
	   }
        if(winW<1028){//補正
		  spread=(1028-winW)/(1028-599)*20;
	   }
    }
    */
    O.put("spread",spread);
	//オブジェクトのベーススケール
	var scaleW=winW/_maxCanW/2*scale;
	var scaleH=winH/_maxCanH/2*scale;
	var baseScale;
    baseScale=spcH/300;
	
	//サイズを返す
	return {
		stageW: canvas.width,
		stageH: canvas.height,
		W: spcW*scale,
		H: spcH*scale,
		spaceW: spcW*scale,
		spaceH: spcH*scale,
		centerX: spcW*scale / 2,
		centerY: spcH*scale / 2,
		isSP:isSP,
		isTB:isTB,
        spread:spread,
		scaleW:scaleW,
		scaleH:scaleH,
		baseScale: baseScale,
		scale: scaleH,
		margin: {x:marLR*scale,y:marTB*scale}
	};
}
	
	
/** ウィンドウのリサイズ時、Canvasをリセット */
function resizeCanvas() {
    var winW = document.documentElement.clientWidth;
    if(winW!=C.size.stageW){
        Q.info("window resize");
        if (C.resizeTimer !== false) {
            window.clearTimeout(C.resizeTimer);
        }else{
            //FOC();
            createjs.Ticker.setPaused(true);
        }

        C.resizeTimer = window.setTimeout(function () {
            Q.info("canvas reset");
            window.removeEventListener('resize', resizeCanvas);
            C.resizeTimer = false;
            createjs.Ticker.setPaused(false);
            resetCanvas();
        }, 1000);
    }
}
	
/** Canvasリセット時の処理 */
function resetCanvas(){
	createjs.Ticker.removeEventListener("tick", C.tick);
	for(var i=0;i<C.stages.length;i++){
		C.stages[i].enableDOMEvents(false);
		C.stages[i].removeAllChildren();
	}
	C.step.reset();
	setCanvas();
    count=0;
}
	
function FOC(){
		for(var i=0;i<C.canvases.length;i++){
			fadeOutC(C.canvases[i]);
		}
}
function FIC(s){
		for(var i=0;i<C.canvases.length;i++){
			fadeInC(C.canvases[i],s);
		}
}
	
/** canvasCSSフェードアウト */
function fadeOutC(canvas,sp){
	//Q.info("fade out!");
    $(canvas).transit({opacity:0.0},100,'ease');
    /*
	createjs.Ticker.addEventListener("tick",{
		handleEvent:function(){
			canvas.style.opacity*=sp||0.7
			if(canvas.style.opacity<0.05){
				canvas.style.opacity=0.0;
				canvas.style.visibility=false;
				//Q.info("fadeOut end!");
				createjs.Ticker.removeEventListener("tick",this);
			}
		}	
	});
    */
}
/** canvasCSSフェードイン */
function fadeInC(canvas,sp){
	//Q.info("fade in!");
    $(canvas).transit({opacity:1.0},100,'ease');
    /*
	createjs.Ticker.addEventListener("tick",{
		handleEvent:function(){
			if(canvas.style.opacity==0.0){canvas.style.opacity=0.01};
			canvas.style.opacity*=sp||1.5;
			if(canvas.style.opacity>1.0){
				canvas.style.opacity=1.0;
				//Q.info("fadeIn end!");
				createjs.Ticker.removeEventListener("tick", this);
			}
		}	
	});
    */
}

/** CJSオブジェクトフェードアウト */
function fadeOut(cjsobj,sp){
	//Q.info("fade out!");
	createjs.Ticker.addEventListener("tick",{
		handleEvent:function(){
			cjsobj.alpha*=sp||0.4;
			if(cjsobj.alpha<0.05){
				cjsobj.alpha=0.0;
				cjsobj.visible=false;
				//Q.info("fadeOut end!");
				createjs.Ticker.removeEventListener("tick",this);
			}
		}	
	});
}
/** CJSオブジェクトフェードイン */
function fadeIn(cjsobj,sp){
	//Q.info("fade in!");
    sp=10;
	createjs.Ticker.addEventListener("tick",{
		handleEvent:function(){
			if(cjsobj.alpha==0.0){cjsobj.alpha=0.01};
			cjsobj.alpha*=sp||5.0;
			if(cjsobj.alpha>1.0){
				cjsobj.alpha=1.0;
				//Q.info("fadeIn end!");
				createjs.Ticker.removeEventListener("tick", this);
			}
		}	
	});
}
	
/** update時のステージ更新 @param {string} color : 上書き色 */
function stageClear(canvas,color){
	canvas.ctx.setTransform(1, 0, 0, 1, 0, 0);
	canvas.ctx.fillStyle = color;
	canvas.ctx.fillRect(0, 0, C.size.stageW, C.size.stageH);
}

/* %から座標を返す */
C.rx=function(x){
    return C.size.W*x/100;
}
C.ry=function(y){
	return C.size.H*y/100;
}

// stage setup //////////////////////////////////////////////////////////
/** Class & house */
var Load=require('./Load.js');
	
var maps=[];
var objs=[];
var constellations=[[],[],[],[]];
var ccatalog={};
var mapTweens=[];
//var ornaments;
var Manim,Mend;
var Ilctnr;
var queue={};
var spr={};
var workstar=[];
var load = new Load(C);
C.endop=false;
var Constellation=require('./cjs.Constellation.js');
var Star=require('./cjs.Star.js');
var starMatrix=[
    {id:"A",stars:[[0,78.8,69.6,1],[1,8.2,31.5,1],[2,83.2,41.6,1],[3,32.8,56.7,1],[4,9.8,65.5,1],[5,93.3,59,1],[6,71.7,12.3,1],[7,41.1,9.4,1],[8,16,23.3,1],[9,64,93.7,1],[10,52.4,95.3,1],[11,27.6,83.5,1],[12,28.8,67.3,1],[13,80.4,28,1],[14,66.6,47.8,1],[15,63.3,74.6,1],[16,56,67.4,1],[17,27.8,46.4,1],[18,66.2,39.4,1],[19,51.6,35.2,1],[20,57.8,23.5,1],[21,41.4,27.2,1],[22,22.9,23.7,1],[23,39.3,43.7,1],[24,38.1,27.2,2],[25,42.5,6.5,2],[26,90.3,57.6,2],[27,81.7,31.1,2],[28,81.6,24.9,2],[29,68.5,41.8,2],[30,72.8,39.4,2],[31,6.8,34.5,2],[32,10.6,68.8,2],[33,6.9,63.8,2],[34,25.7,66.1,2],[35,25.7,68.6,2],[36,31.8,66,2],[37,25.6,45.8,2],[38,58,25.8,2],[39,59.6,25,2],[40,43.8,29.5,2],[41,41.6,41.4,2],[42,49.2,35.5,2],[43,79.4,42.3,3],[44,69.2,18.4,3],[45,69.2,6.1,3],[46,58.1,96.8,3],[47,21.7,80.4,3],[48,29.6,89.8,3],[49,33.5,86.6,3],[50,24.8,58.2,3],[51,59.6,51.6,3],[52,73.5,44,3],[53,57.3,71.7,3],[54,61.1,68.3,3],[55,66.1,68.6,3],[56,48,56.8,3],[57,32.3,47.5,3],[58,23.9,48.7,3],[59,54.6,31.4,3],[60,55.4,38.2,3],[61,52.2,40,3],[62,48.6,39,3],[63,27.9,28.1,3],[64,48.7,53.1,3],[65,57.4,57.5,4],[66,52.4,85.3,4],[67,59,83.6,4],[68,53.9,77.9,4],[69,81.8,79.1,4],[70,83.9,62.3,4],[71,70,65,4],[72,37.7,0.1,4],[73,32.1,5.1,4],[74,31.6,12.7,4],[75,29.5,16.2,4],[76,33.8,42.9,4],[77,29.6,39.7,4],[78,24.3,40.5,4],[79,32.2,74.6,4],[80,20.6,26.7,4],[81,12.7,27.9,4],[82,11.4,20,4],[83,15.1,17.7,4],[84,39.3,33.8,4],[85,41.4,17.2,4],[86,62.5,18.3,4],[87,73.2,32.4,4],[88,66.2,29.5,4],[89,86.4,36.8,4],[90,82.1,35.9,4],[91,78.4,38.4,4],[92,80,46.3,4],[93,88,44.8,4],[94,88.8,40.4,4],[95,77.9,51.1,4],[96,55.2,44.5,4],[97,60.9,37.4,4],[98,75.7,87.4,5],[99,67.9,81,5],[100,43,85.9,5],[101,45.5,75.4,5],[102,96.7,68.5,5],[103,90.5,75.7,5],[104,74.2,61.7,5],[105,12.8,43.9,5],[106,23.8,37,5],[107,40.4,58.7,5],[108,25.1,54.7,5],[109,28.8,49.8,5],[110,41.2,72.1,5],[111,4.8,74.3,5],[112,21.1,72.4,5],[113,6.6,52.6,5],[114,16.6,54.1,5],[115,20.5,17.2,5],[116,50.8,17.8,5],[117,53.6,5.1,5],[118,84,17.4,5],[119,59.5,7.2,5],[120,67.1,23,5],[121,92.7,32.9,5],[122,88.9,46.5,5]]},
    {id:"B",stars:[[0,29.5,53,1],[1,55.4,89.3,1],[2,2.2,50,1],[3,96.2,60.7,1],[4,84.8,71.4,1],[5,78.9,83,1],[6,41.6,76.7,1],[7,24.8,71.6,1],[8,61.7,71.4,1],[9,53.7,50.6,1],[10,14,61.4,1],[11,70,51.2,1],[12,26.1,42.2,1],[13,63.8,26.6,1],[14,48.9,29.5,1],[15,86.2,39.5,1],[16,66.3,11.8,1],[17,50.5,6.5,1],[18,32.5,49.9,2],[19,53.4,86.9,2],[20,30.1,88.1,2],[21,28.4,93.7,2],[22,4.6,51.7,2],[23,5.1,49.5,2],[24,1.7,47.2,2],[25,80.6,72.9,2],[26,88.8,73.2,2],[27,83.4,80.5,2],[28,83.8,84.4,2],[29,74.4,85.5,2],[30,44.3,75.5,2],[31,27.7,71.5,2],[32,63.6,71,2],[33,63.3,72.5,2],[34,54,46.4,2],[35,15.1,59.1,2],[36,13,63.8,2],[37,15,63.9,2],[38,71.8,48.8,2],[39,30.5,42.2,2],[40,8.5,33.9,2],[41,10.6,34.7,2],[42,12.5,29.6,2],[43,64.2,29.5,2],[44,45.3,30.7,2],[45,45.4,27.8,2],[46,75.5,18.6,2],[47,77.3,16.7,2],[48,80,16.6,2],[49,82,21.1,2],[50,83.3,39.5,2],[51,84.1,37.5,2],[52,69.2,12,2],[53,52.6,8.6,2],[54,86.2,33.7,3],[55,35.4,58.7,3],[56,29.5,44.5,3],[57,24.2,93.7,3],[58,94,51.1,3],[59,76.7,67.7,3],[60,9.3,59.4,3],[61,14.7,35.7,3],[62,52.2,22.6,3],[63,56.1,26.9,3],[64,72.4,22.7,3],[65,90.3,35.4,3],[66,86.2,45.4,3],[67,70.8,8,3],[68,60.6,11.3,3],[69,62.6,7.4,3],[70,46.4,2.4,3],[71,56.3,6.5,3],[72,50.5,0.7,3],[73,28.1,22.3,3],[74,35.3,18.4,3],[75,47.9,95.5,4],[76,62.9,83.2,4],[77,33.5,98.4,4],[78,37.6,93.3,4],[79,25.1,83.2,4],[80,38,68.8,4],[81,44.7,68.5,4],[82,30.7,65.2,4],[83,56.7,68,4],[84,44.1,58.6,4],[85,45.6,41,4],[86,18.8,63.5,4],[87,11.2,54.2,4],[88,76.9,56.5,4],[89,69,42.6,4],[90,63.2,45.8,4],[91,61.4,52.2,4],[92,16.9,51.3,4],[93,26.2,29.1,4],[94,35.4,32.9,4],[95,70.6,32,4],[96,88.2,15.6,4],[97,75.1,29.5,4],[98,92.3,45.7,4],[99,72,18.4,4],[100,59.7,17.4,4],[101,41.8,6.5,4],[102,44.4,12.7,4],[103,50.5,15.2,4],[104,33.9,24.4,4],[105,32.2,8.4,4],[106,46.2,52.8,5],[107,42.6,88.1,5],[108,59.6,94.4,5],[109,18.1,87.6,5],[110,39.4,85.3,5],[111,8.7,40.5,5],[112,77,65,5],[113,59.2,77.4,5],[114,30.8,72.7,5],[115,52.5,80.7,5],[116,16.9,80.1,5],[117,13.2,72.1,5],[118,24.4,60,5],[119,66.2,64.7,5],[120,64.4,63.3,5],[121,4.4,65.2,5],[122,81.6,49.8,5],[123,22.1,31.4,5],[124,56.6,35.8,5],[125,43.9,15,5],[126,84.3,32.5,5],[127,97.8,39.5,5],[128,24.1,6.6,5],[129,18.6,13.4,5],[130,19.5,22.3,5],[131,39.9,11.2,5]]},
    {id:"C",stars:[[0,87.8,56.8,1],[1,81.2,32.4,1],[2,26.1,80.9,1],[3,9.7,47.3,1],[4,65.6,99.9,1],[5,48.2,89.2,1],[6,41.2,70.6,1],[7,52.5,55.5,1],[8,79.6,78.8,1],[9,68.6,61.8,1],[10,32.1,77,1],[11,10.9,61.9,1],[12,23.9,56.2,1],[13,43.8,43.8,1],[14,93.7,47.8,1],[15,81.7,45.6,1],[16,73.9,19.3,1],[17,53.2,26,1],[18,55.9,14.1,1],[19,38.7,14.6,1],[20,29.4,12.3,1],[21,10.9,26.8,1],[22,8,50.3,2],[23,8.8,44,2],[24,51.4,91.4,2],[25,45.1,70.6,2],[26,41.2,66.7,2],[27,33.4,73.3,2],[28,88.2,52.9,2],[29,34.3,44.2,2],[30,37.1,43.1,2],[31,38.2,40.3,2],[32,31.5,37.5,2],[33,80.1,24.2,2],[34,55.6,23,2],[35,41.5,11.9,2],[36,46.5,14.8,3],[37,24.7,73.2,3],[38,65.6,91.9,3],[39,49.6,96.9,3],[40,62.1,66.1,3],[41,76.3,63.4,3],[42,15.6,68.2,3],[43,3.1,60.9,3],[44,11.9,54.2,3],[45,41.3,45,3],[46,41.2,42.9,3],[47,87.1,43.4,3],[48,98,41.2,3],[49,83.1,40.4,3],[50,84.6,30,3],[51,83.5,35.8,3],[52,73,11.5,3],[53,74.9,27.1,3],[54,33,20,3],[55,27.7,4.1,3],[56,30.9,20,3],[57,18,23.2,3],[58,16.4,74.2,4],[59,14.5,83,4],[60,35.8,87.6,4],[61,0.8,42.2,4],[62,14.8,38.4,4],[63,66.8,52.3,4],[64,79.6,67,4],[65,27.2,66.3,4],[66,22.5,63.6,4],[67,80.3,47.7,4],[68,99.6,58,4],[69,77.6,38.6,4],[70,26,48.6,4],[71,42.7,32,4],[72,34.3,28.5,4],[73,51.9,14.3,4],[74,62.3,33.4,4],[75,48.6,4.8,4],[76,57.3,2.4,4],[77,67.6,15.4,4],[78,46.8,23.1,4],[79,38.4,26.3,4],[80,3.3,30.5,4],[81,22.1,30.4,4],[82,76.6,88.7,5],[83,32.8,92.1,5],[84,63.6,86.3,5],[85,57,76.2,5],[86,52.2,59.5,5],[87,62.9,38.9,5],[88,90.7,67.7,5],[89,65.4,77.3,5],[90,46.8,82.5,5],[91,28.3,59,5],[92,19.5,53.3,5],[93,22.8,51,5],[94,72.2,55.2,5],[95,41.9,49,5],[96,45.6,38.6,5],[97,71.2,42.9,5],[98,18.6,40.3,5],[99,74.3,37.1,5],[100,89.5,17.4,5],[101,68.8,24.3,5],[102,39.2,-0.9,5],[103,20.7,25.3,5]]},
    {id:"D",stars:[[0,18,31.8,1],[1,35.1,37.8,1],[2,68.7,70.7,1],[3,31.2,89.9,1],[4,68.2,84.4,1],[5,89.4,69.8,1],[6,63.9,60.7,1],[7,45.6,72.4,1],[8,13.2,75.6,1],[9,85.7,54.3,1],[10,90.4,40.5,1],[11,61.8,46.9,1],[12,47.9,32.7,1],[13,13.2,50.3,1],[14,88,26.1,1],[15,35.3,12.9,1],[16,63.6,5.2,1],[17,57.5,61.8,1],[18,43.5,20.1,1],[19,58.9,19.7,1],[20,36.3,54.3,1],[21,67.5,38.2,1],[22,47.8,93.6,1],[23,35.5,36.1,2],[24,69.9,68.7,2],[25,68.1,68.4,2],[26,33.3,93.2,2],[27,64.4,83.9,2],[28,92.6,67.7,2],[29,82.5,53.3,2],[30,63.3,9.4,2],[31,58.7,60.8,2],[32,21.7,32.9,2],[33,43.3,22.7,2],[34,55,19.7,2],[35,56.1,17,2],[36,34.3,41.3,3],[37,73.3,69.6,3],[38,29.5,97.4,3],[39,20,87.3,3],[40,25.2,80.2,3],[41,33.9,78.7,3],[42,38.7,91.7,3],[43,72.9,90.5,3],[44,59.1,91.5,3],[45,38.7,74.2,3],[46,83.7,60.7,3],[47,87.6,47.9,3],[48,82.5,48.4,3],[49,97.5,37.4,3],[50,87.4,33.4,3],[51,69,45.5,3],[52,41.9,37.4,3],[53,47,40.3,3],[54,52.6,38.7,3],[55,55.5,33.5,3],[56,7.5,55.5,3],[57,83.6,23.9,3],[58,89.5,30.8,3],[59,36.7,18.2,3],[60,30.6,10.1,3],[61,71.9,5.7,3],[62,15.9,39.2,3],[63,24.8,28.1,3],[64,47.6,16.8,3],[65,39.9,16.3,3],[66,38,19.8,3],[67,66.5,19.7,3],[68,42.5,58.9,3],[69,31.8,60.5,3],[70,35.1,46.7,3],[71,30.1,49.8,3],[72,47.4,97.9,3],[73,50.6,96.9,3],[74,44.4,96.4,3],[75,59.1,91.5,4],[76,93.3,75.6,4],[77,69.5,65.5,4],[78,76.8,59,4],[79,21.7,42.5,4],[80,93.8,24.2,4],[81,85.7,19.1,4],[82,60.5,65.3,4],[83,38.1,65.7,4],[84,41.9,39.5,5],[85,29.1,41.5,5],[86,28.2,36.2,5],[87,31.4,31.8,5],[88,71,80,5],[89,76.9,75.7,5],[90,92.3,54.7,5],[91,76.7,78.4,5],[92,70.3,53.2,5],[93,49,86.1,5],[94,33.4,65.1,5],[95,59.3,69,5],[96,2.8,67.7,5],[97,28.4,73.6,5],[98,47.5,49.7,5],[99,53.7,59,5],[100,2.9,38.9,5],[101,23.6,61.7,5],[102,78.6,29.2,5],[103,24.7,15.7,5],[104,46,10.1,5],[105,46.9,4.2,5],[106,52.9,65.8,5],[107,22.3,17.1,5],[108,4.2,27.7,5],[109,50.7,27.8,5],[110,35.2,26.8,5],[111,58.9,35.1,5],[112,71.1,24.6,5],[113,56.4,94.3,5],[114,54.4,87.9,5]]}
]
var nameMatrix=[[69.4,35.3],[51.3,37.4],[62.5,21.9],[44.2,21.4],[27.9,34.2],[33.1,70.3],[78.9,30.2],[60.7,45.1],[59.4,74.4],[54.2,60.8],[91.1,62],[81.7,38.4],[6.8,38.8],[84.1,75.2],[15.4,20],[69.5,87.5],[49.3,88.1],[67,8.4],[37,6.6],[29,54.6],[10.8,56.5],[25.7,86.1],[29,43.6],[40.6,47.4],[91.4,39.5],[65.4,32.3],[92.4,63.2],[84.7,73.1],[79.2,85],[38.7,72.5],[66.1,70.3],[53.2,53.7],[75.9,51.9],[77.7,23.1],[49.3,24.8],[65.7,16.5],[47.7,8.3],[36,55.7],[50.5,89.7],[31.8,90.7],[3.8,48],[18,75.2],[11.6,60.5],[30.7,36.2],[14.5,32.7],[27.9,14.8],[22.3,57.5],[38.1,80.7],[55.7,86],[13,46.8],[44.6,66.8],[60.9,49.4],[16.4,64.9],[45.6,46.4],[61,27],[76.9,42.3],[83.5,70.5],[20.5,77.8],[68.8,93.2],[65,67.2],[81.3,52.5],[97.3,46.6],[79.3,36.1],[78.2,21.8],[53.8,7],[36.7,35],[40.8,19.1],[27.9,19],[16.5,26.6],[21.7,28.8],[40.1,21.9],[61.3,21.5],[37.1,59.7],[72.2,30.2],[94.5,40.7],[85.1,25.5],[66.4,6.8],[81.4,58.2],[31.7,35.9],[72.5,73.8],[63.6,90.2],[81.7,77],[69.4,63.1],[53.9,52.3],[48.7,36.5],[44.9,80],[27.5,84.8],[20.2,75.8],[17.2,57.5],[33.6,14.7],[52.3,63.5],[51.6,93.7],[78.2,21.8]];
// setting - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */ 
function onYourMark(){
	//C.getHeights();//縦幅取得
	Q.info(load.complete);
        
    
	if(!load.complete){//ロードがおわっていない
		//load.open(M);//ロード画面表示
		Q.info("準備");
        
		//素材準備
		queue = new createjs.LoadQueue(false);
		queue.loadManifest([
				{id: "s0",src: "./c/s0.png"},
				{id: "s1",src: "./c/s1.png"},
				{id: "s2",src: "./c/s2.png"},
				{id: "s3",src: "./c/s3.png"},
				{id: "s4",src: "./c/s4.png"},
				{id: "s5",src: "./c/s5.png"}
        ]);
		queue.on("progress",function(e){
			//load.progress(e)
		}, this);
		
		queue.on("complete", function(){
		      Q.info("ロード完了");
                Constellation.set(C,S,queue,starMatrix,nameMatrix);
			// スプライトシート生成
            /*
			var makeSpr=(function(){
			spr={};
			spr.M = new createjs.SpriteSheet({
				images: [queue.getResult("manim1"),queue.getResult("manim2"),queue.getResult("manim3")],
				frames: [[0,0,800,450,0,0,0],[800,0,800,450,0,0,0],[1600,0,800,450,0,0,0]]
                //framerate: 15,
			});
            */ 
                
			//
				setTimeout(ready,50);
 		createjs.Ticker.paused = false;
			load.close().done(function(){
                //readyになおす
				load.complete=true;
			});
		  }, this);
	}else{//リサイズ等ですでにロードずみ。
        Q.info("ロード済み");
		already();
	}
    
	function ready(){ //アニメーション開始
        Q.info("配置");
        FIC();
        fadeIn(S.stage);
        fadeIn(B.stage);
        fadeIn(W.stage);
        //fadeInC(GL.canvas);
        setMap();
        setStarBacks();
        getConstellation();
        setBack();
	}
    
	function already(){  
		Q.info("already");
	}
		
}

function getConstellation(){
    $.getJSON(
        "csdata.json",
        null,
        function (json) {
                //Q.info(json);
            for(var i=0;i<json.length;i++){
                //Q.info(json[i].class,json[i].cdata,json[i].name,json[i].npos);
                setConstellation(json[i].class,json[i].number,json[i].cdata,json[i].name,json[i].npos);
            }
            mapChange(0);
        }
    );
}
    
function setConstellation(cls,num,parts,name,npos){
        var clsN;
        switch(cls){
            case "A":clsN=0;break;
            case "B":clsN=1;break;
            case "C":clsN=2;break;
            case "D":clsN=3;break;
        }
        var z=new Constellation(C,clsN,parts,name,npos);
        var zz=new Constellation(C,clsN,parts,name,npos);
        maps[clsN].addChild(z.constellation);
        objs.push(z);
        constellations[clsN].push(z);
        ccatalog[cls+num]=zz;
        objs.push(zz);
    
};

C.getConstellationJ=function(id){
    Q.info(id)
    workstar=[];
        W.stage.removeAllChildren();
        if(ccatalog[id]!==undefined){
            var cs=ccatalog[id];
            cs.view2();
            cs.constellation2.x=W.size.centerX*1.1;
            cs.constellation2.y=W.size.centerY*0.8;
            W.stage.addChild(cs.constellation2);
            workstar.push(cs);
        }
}

function setMap(){
    maps=[];
    constellations=[[],[],[],[]];
    
    for(var i=0;i<4;i++){//ABCD
        maps[i]=new createjs.Container();
        maps[i].set({regX:C.size.centerX,regY:C.size.centerY,x:C.size.centerX,y:C.size.centerY});
        S.space.addChild(maps[i]);
    }
}
function mapChange(i){
    var cs=_.shuffle(constellations[i]);
    for(var u=0;u<cs.length;u++){
        cs[u].view(u);
        //Q.info(constellations[i][u]);
    }
}
var starbacks,mapTweens2;

function setStarBacks(){
    starbacks=[];
    mapTweens2=[];
    for(var i=0;i<4;i++){//ABCD
        starbacks[i]=new createjs.Container();
        starbacks[i].set({regX:C.size.centerX,regY:C.size.centerY,x:C.size.centerX,y:C.size.centerY});
        
        for(var j=0;j<starMatrix[i].stars.length;j++){//stars\
                var s=starMatrix[i].stars[j];
                var ss=new Star(C,queue.getResult("s0"),{index:s[0],x:C.rx(s[1]),y:C.ry(s[2]),level:0});
                starbacks[i].addChild(ss.star);
                starbacks[i].alpha=0.8;
                objs.push(ss);
        }
        /*
        (function(i){
            starbacks[i].alpha=0.0;
            setTimeout(function(){
                mapTweens2[i]=createjs.Tween.get(starbacks[i],{loop:true})
                    .to({alpha:1.0},2000).wait(2000).to({alpha:0.0},2000).wait(18000);
            },i*8000+1000);
        }(i))
        */
        S.space.addChild(starbacks[i]);
    }
}
    
function setBack(){
        for(var j=0;j<B.size.spaceW/2;j++){//stars\
                var ss=new Star(C,queue.getResult("s0"),{
                    index:0,
                    x:B.size.spaceW*Math.random(),
                    y:B.size.spaceH*Math.random(),
                    level:0,
                    addscale:0.2
                });
                objs.push(ss);
                B.space.addChild(ss.star);
            Q.info(ss);
        }
        /*
        (function(i){
            starbacks[i].alpha=0.0;
            setTimeout(function(){
                mapTweens2[i]=createjs.Tween.get(starbacks[i],{loop:true})
                    .to({alpha:1.0},2000).wait(2000).to({alpha:0.0},2000).wait(18000);
            },i*8000+1000);
        }(i))
        */
}



function objClear(){
	S.space.removeAllChildren();
	//GL.stage.removeAllChildren();
	C.step.reset();
    stageClear(S,"rgba(255, 255, 255, 1.0)");
};
//interaction

/////////////////////////////////////////////////////////////////////////

/* (o_o) */
var count=0;
var mapcount=0;
function updateCanvas(step,max){    
// update ///////////////////////////////////////////////////////////////
/** clear */ 
	stageClear(S,"rgba(0,15,32, 0.8)");
	stageClear(W,"rgba(0,15,"+step+", 0.8)");

	//update
	for(var i=0;i<objs.length;i++){
		objs[i].up(step,max);
	}
	for(var i=0;i<workstar.length;i++){
		workstar[i].up2(step,max);
	}
	for(var i=0;i<maps.length;i++){
		maps[i].rotation+=0.05;
		starbacks[i].rotation+=0.05;
	}
    count++;
    if(count===330){
        mapcount++;
        mapChange(mapcount%4);
        count=0;
    }
/////////////////////////////////////////////////////////////////////////
}

    
    
// endmodule - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
return C;
/////////////////////////////////////////////////////////////////////////
})();
return Mo;
});

